import {Component, OnInit} from '@angular/core';
import {PriceRobotProductsService} from '../services/price-robot-products.service';
import {PriceRobotProduct} from '../services/price-robot-product';
import {PriceRobotFilter} from '../services/price-robot-filter';
import {PriceRobotMessageService} from '../services/price-robot-message.service';
import {forkJoin, Subject} from 'rxjs';
import {CategoriesService, Category, VariantGroup, VariantGroupsService} from '@hassel-it/shop-services';
import {UsersService} from '@hassel-it/angular-common';
import {ActivatedRoute, Router} from '@angular/router';
import {PriceRobotUsersService} from "../services/price-robot-users.service";
import {ProductsService} from "../services/products.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    providers: [VariantGroupsService, CategoriesService, PriceRobotUsersService, ProductsService],
    selector: 'app-price-robot-products',
    templateUrl: './price-robot-products.component.html',
    styleUrls: ['./price-robot-products.component.scss'],
})
export class PriceRobotProductsComponent implements OnInit {

    public data: any;
    public products: PriceRobotProduct[] = [];
    public meta: any;
    public pageNr: number = 1;
    public order: string = '';
    public modifier: number = 0;
    public filter: PriceRobotFilter = new PriceRobotFilter();
    public previousFilter: PriceRobotFilter = new PriceRobotFilter();
    public variantGroups: VariantGroup[];
    public categories: Category[];
    public users: any;
    public loading: boolean = false;
    public changed: boolean = false;
    public paginationChanged: Subject<boolean> = new Subject();
    public productIds = [];

    constructor(private priceRobotProductsApiService: PriceRobotProductsService,
                private variantGroupsService: VariantGroupsService,
                private categoriesService: CategoriesService,
                private priceRobotMessageService: PriceRobotMessageService,
                private usersService: UsersService,
                private priceRobotUsersService: PriceRobotUsersService,
                private productsService: ProductsService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private modalService: NgbModal) {
    }

    ngOnInit(): void {

        forkJoin([
            this.variantGroupsService.getVariantGroups({all: true, withVariants: true}),
            this.priceRobotUsersService.getUsers(1, {all: true}),
            this.categoriesService.getCategoriesAdmin({}),
            this.usersService.getCurrentUser()]
        ).subscribe(data => {
            this.variantGroups = data[0].results;
            this.users = data[1].results;
            this.categories = data[2].results.sort((a, b) => {
                return (a.name > b.name) ? 1 : -1
            });
        });

        this.activatedRoute.queryParams.subscribe(result => {

            if (result.page) {
                this.pageNr = result.page;
            }

            if (result.filter) {
                const filter = PriceRobotFilter.fromJSON(JSON.parse(result.filter));
                // filter.currentUser = result['currentUser'] === 'true';
                // filter.pending = result['pending'] === 'true';
                // filter.withErrors = result['withErrors'] === 'true';
                //
                this.setFilter(filter);
            } else {
                this.setFilter(PriceRobotFilter.fromJSON({}));
            }
        });
    }

    setFilter(filter: PriceRobotFilter) {
        this.filter = filter;
        this.loadData();
    }

    refresh(pageNr, sort: string = null, direction: string = null) {
        this.pageNr = pageNr;
        if (this.filter.sort === sort) {
            if (direction === 'DESC') {
                direction = 'ASC';
            } else {
                direction = 'DESC';
            }
        }

        if (sort) {

            this.filter.sort = sort;
        }
        if (direction) {
            this.filter.direction = direction;
        }
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
                page: pageNr,
                filter: JSON.stringify(this.filter)
            }
        });
    }

    loadData() {
        this.loading = true;
        this.priceRobotProductsApiService.index(this.pageNr, this.filter).subscribe((result) => {
            this.products = result.results;
            this.meta = {count: result.count};
            this.productIds = [];
            this.products.forEach((product) => {
                this.productIds.push(product.id);
            })
            this.loading = false;
            this.paginationChanged.next(true);
        }, (error) => {
            this.priceRobotMessageService.handleError(error);
        }, () => {
        })
    }

    resetSearch() {
        this.filter = new PriceRobotFilter();
        this.order = '';
        this.refresh(1);
    }

    overwriteFilter(filter: PriceRobotFilter) {
        this.filter = filter
        this.refresh(1);
    }

    openModal(content: any) {
        this.modalService.open(content, {size: 'xl'});
    }
}
